export default "__VITE_ASSET__cd00a1df__"